import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import * as globals from '../../components/GlobalScripts.js';

import '../../styles/admin/platillos.css';

function getPathApi() {
    return String(localStorage.getItem('path_api') || '').replace(/\/$/, '');
}

function safeJsonParse(maybeJson, fallback = {}) {
    try {
        if (typeof maybeJson === 'string') return JSON.parse(maybeJson);
        if (maybeJson && typeof maybeJson === 'object') return maybeJson;
    } catch { }
    return fallback;
}

function normalizeFromRow(row) {
    const r = row || {};
    const d = safeJsonParse(r.data, {});
    const nut = d.nutricion || {};
    const resumen = nut.resumen || {};

    const defaultsTabla = {
        calorias_kcal: Number(nut.tabla?.calorias_kcal ?? resumen.kcal ?? 0) || 0,
        grasas_totales_g: Number(nut.tabla?.grasas_totales_g ?? resumen.grasas ?? 0) || 0,
        grasas_saturadas_g: Number(nut.tabla?.grasas_saturadas_g ?? 0) || 0,
        grasas_trans_g: Number(nut.tabla?.grasas_trans_g ?? 0) || 0,
        colesterol_mg: Number(nut.tabla?.colesterol_mg ?? 0) || 0,
        sodio_mg: Number(nut.tabla?.sodio_mg ?? 0) || 0,
        carbohidratos_totales_g: Number(nut.tabla?.carbohidratos_totales_g ?? resumen.carbohidratos ?? 0) || 0,
        fibra_dietetica_g: Number(nut.tabla?.fibra_dietetica_g ?? 0) || 0,
        azucares_totales_g: Number(nut.tabla?.azucares_totales_g ?? 0) || 0,
        azucares_anadidos_g: Number(nut.tabla?.azucares_anadidos_g ?? 0) || 0,
        proteinas_g: Number(nut.tabla?.proteinas_g ?? resumen.proteinas ?? 0) || 0,
    };

    return {
        id: r.id ?? null,
        tipo: String(r.tipo || d.tipo || 'entrada'),
        activo: Number(r.activo ?? d.activo ?? 1) ? 1 : 0,

        nombre: String(d.nombre || ''),
        descripcion: String(d.descripcion || ''),
        alergeno: String(d.alergenos_disclaimer || ''),

        imagenes: Array.isArray(d.imagenes) ? d.imagenes.filter(Boolean).map(String) : [],

        nutricion: {
            resumen: {
                kcal: Number(resumen.kcal ?? nut.kcal ?? 0) || 0,
                proteinas: Number(resumen.proteinas ?? nut.proteinas ?? 0) || 0,
                carbohidratos: Number(resumen.carbohidratos ?? nut.carbohidratos ?? 0) || 0,
                grasas: Number(resumen.grasas ?? nut.grasas ?? 0) || 0,
            },
            porcion: {
                tamano: String(nut.porcion?.tamano ?? ''),
                unidad: String(nut.porcion?.unidad ?? 'g'),
                porciones_por_envase: String(nut.porcion?.porciones_por_envase ?? ''),
            },
            tabla: defaultsTabla,
            extra: Array.isArray(nut.extra) ? nut.extra.map((x) => ({
                nombre: String(x?.nombre ?? ''),
                cantidad: String(x?.cantidad ?? ''),
                unidad: String(x?.unidad ?? ''),
                vd: String(x?.vd ?? ''),
            })) : [],
            notas: String(nut.notas ?? ''),
        },
    };
}

function IconChevronLeft(props) { return (<svg viewBox="0 0 24 24" fill="none" {...props}><path d="M15 18 9 12l6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>); }
function IconPlus(props) { return (<svg viewBox="0 0 24 24" fill="none" {...props}><path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" /></svg>); }
function IconSave(props) { return (<svg viewBox="0 0 24 24" fill="none" {...props}><path d="M5 20h14a2 2 0 0 0 2-2V8l-4-4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z" stroke="currentColor" strokeWidth="2" /><path d="M7 20V12h10v8" stroke="currentColor" strokeWidth="2" /><path d="M8 4v4h8" stroke="currentColor" strokeWidth="2" /></svg>); }
function IconX(props) { return (<svg viewBox="0 0 24 24" fill="none" {...props}><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" /></svg>); }
function IconTrash(props) { return (<svg viewBox="0 0 24 24" fill="none" {...props}><path d="M4 7h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /><path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /><path d="M6 7l1 14h10l1-14" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" /><path d="M9 7V4h6v3" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" /></svg>); }
function IconArrowUp(props) { return (<svg viewBox="0 0 24 24" fill="none" {...props}><path d="M12 5v14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /><path d="M6 11l6-6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>); }
function IconArrowDown(props) { return (<svg viewBox="0 0 24 24" fill="none" {...props}><path d="M12 19V5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /><path d="M6 13l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>); }
function IconStar(props) { return (<svg viewBox="0 0 24 24" fill="none" {...props}><path d="m12 3 2.6 6.4 6.9.6-5.2 4.5 1.6 6.8L12 17.9 6.1 21.3l1.6-6.8L2.5 10l6.9-.6L12 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" /></svg>); }

export default function AdminPlatilloEditor() {
    const nav = useNavigate();
    const params = useParams();
    const loc = useLocation();

    const id = params?.id ? String(params.id) : '';
    const isNew = loc.pathname.endsWith('/nuevo');
    const isEdit = loc.pathname.includes('/editar');
    const isClone = loc.pathname.includes('/clonar');

    const mode = isNew ? 'create' : isClone ? 'clone' : 'edit';

    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const [dirty, setDirty] = useState(false);

    const blobUrlsRef = useRef(new Set());

    const [form, setForm] = useState(() => ({
        id: null,
        nombre: '',
        tipo: 'entrada',
        descripcion: '',
        alergeno: '',
        activo: 1,
        imagenes: [],
        nutricion: {
            resumen: { kcal: 0, proteinas: 0, carbohidratos: 0, grasas: 0 },
            porcion: { tamano: '', unidad: 'g', porciones_por_envase: '' },
            tabla: {
                calorias_kcal: 0,
                grasas_totales_g: 0,
                grasas_saturadas_g: 0,
                grasas_trans_g: 0,
                colesterol_mg: 0,
                sodio_mg: 0,
                carbohidratos_totales_g: 0,
                fibra_dietetica_g: 0,
                azucares_totales_g: 0,
                azucares_anadidos_g: 0,
                proteinas_g: 0,
            },
            extra: [],
            notas: '',
        },
    }));

    const [images, setImages] = useState([]);

    const busyRef = useRef(0);
    const busyWrap = async (fn) => {
        try {
            if (busyRef.current === 0) {
                globals.openViewCharge();
                await new Promise(requestAnimationFrame);
            }
            busyRef.current += 1;
            return await fn();
        } finally {
            busyRef.current = Math.max(0, busyRef.current - 1);
            if (busyRef.current === 0) globals.closeViewCharge();
        }
    };

    const setField = (path, value) => {
        setDirty(true);
        setForm((prev) => {
            const next = structuredClone(prev);
            const keys = path.split('.');
            let cur = next;
            for (let i = 0; i < keys.length - 1; i++) cur = cur[keys[i]];
            cur[keys[keys.length - 1]] = value;
            return next;
        });
    };

    const hydrateImagesFromUrls = (urls) => {
        const existing = Array.isArray(urls) ? urls : [];
        setImages(existing.map((url, idx) => ({
            key: `ex_${idx}_${url}`,
            kind: 'existing',
            url,
        })));
    };

    const loadPlatillo = async () => {
        if (mode === 'create') {
            setDirty(false);
            return;
        }

        const path_api = getPathApi();
        const payload = {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: id,
        };

        setLoading(true);

        try {
            await busyWrap(async () => {
                const res = await axios.post(`${path_api}/admin/platillos/get.php`, payload);

                if (res.data?.mensaje !== 'success') {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: res.data?.mensaje || "No se pudo cargar el platillo",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000
                    });
                    nav('/admin/platillos');
                    return;
                }

                const row = res.data?.item || res.data?.row || res.data?.data || null;
                const norm = normalizeFromRow(row);

                if (mode === 'clone') {
                    norm.id = null;
                    norm.activo = 1;
                    norm.nombre = norm.nombre ? `${norm.nombre} (copia)` : 'Nuevo platillo (copia)';
                }

                setForm(norm);
                hydrateImagesFromUrls(norm.imagenes);
                setDirty(false);
            });
        } catch (e) {
            console.error(e);
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar el platillo",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
            nav('/admin/platillos');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const st = loc.state?.platillo;
        if ((mode === 'edit' || mode === 'clone') && st) {
            const norm = normalizeFromRow(st);
            if (mode === 'clone') {
                norm.id = null;
                norm.activo = 1;
                norm.nombre = norm.nombre ? `${norm.nombre} (copia)` : 'Nuevo platillo (copia)';
            }
            setForm(norm);
            hydrateImagesFromUrls(norm.imagenes);
            setDirty(false);
            return;
        }
        loadPlatillo();
    }, [id, mode]);

    useEffect(() => {
        return () => {
            blobUrlsRef.current.forEach((u) => {
                try { URL.revokeObjectURL(u); } catch { }
            });
            blobUrlsRef.current.clear();
        };
    }, []);

    const handleBack = () => {
        if (dirty) {
            const ok = window.confirm('Tienes cambios sin guardar. ¿Salir de todos modos?');
            if (!ok) return;
        }
        nav('/admin/platillos');
    };

    const handlePickImages = (fileList) => {
        const files = Array.from(fileList || []).filter(Boolean);
        if (!files.length) return;

        const mapped = files.map((f, idx) => {
            const url = URL.createObjectURL(f);
            blobUrlsRef.current.add(url);

            return {
                key: `new_${Date.now()}_${idx}_${f.name}`,
                kind: 'new',
                file: f,
                url,
            };
        });

        setDirty(true);
        setImages((p) => [...p, ...mapped]);
    };

    const moveImage = (fromIdx, toIdx) => {
        setImages((prev) => {
            if (fromIdx < 0 || toIdx < 0 || fromIdx >= prev.length || toIdx >= prev.length) return prev;
            const next = [...prev];
            const [it] = next.splice(fromIdx, 1);
            next.splice(toIdx, 0, it);
            setDirty(true);
            return next;
        });
    };

    const removeImage = (idx) => {
        setImages((prev) => {
            const next = [...prev];
            const it = next[idx];

            if (it?.kind === 'new' && it.url?.startsWith('blob:')) {
                try { URL.revokeObjectURL(it.url); } catch { }
                blobUrlsRef.current.delete(it.url);
            }

            next.splice(idx, 1);
            setDirty(true);
            return next;
        });
    };

    const addExtraNutriente = () => {
        setDirty(true);
        setForm((p) => ({
            ...p,
            nutricion: {
                ...p.nutricion,
                extra: [
                    ...(p.nutricion.extra || []),
                    { nombre: '', cantidad: '', unidad: '', vd: '' },
                ],
            },
        }));
    };

    const updateExtraNutriente = (idx, key, val) => {
        setDirty(true);
        setForm((p) => {
            const next = structuredClone(p);
            next.nutricion.extra[idx][key] = val;
            return next;
        });
    };

    const removeExtraNutriente = (idx) => {
        setDirty(true);
        setForm((p) => {
            const next = structuredClone(p);
            next.nutricion.extra.splice(idx, 1);
            return next;
        });
    };

    const validate = () => {
        if (!String(form.nombre || '').trim()) return 'El nombre es obligatorio.';
        if (!String(form.tipo || '').trim()) return 'El tipo es obligatorio.';
        return '';
    };

    const handleSave = async () => {
        const err = validate();
        if (err) {
            globals.createAlert({ type: "advertencia", msg_title: "Revisa", msg: err, effect: "opacidad 1s, desplazamiento 1s", time_life: 2500 });
            return;
        }

        const path_api = getPathApi();
        setSaving(true);

        const dataPayload = {
            nombre: String(form.nombre || '').trim(),
            descripcion: String(form.descripcion || '').trim(),
            imagenes: [],
            alergenos_disclaimer: String(form.alergeno || '').trim(),

            nutricion: {
                resumen: {
                    kcal: Number(form.nutricion.resumen.kcal || 0) || 0,
                    proteinas: Number(form.nutricion.resumen.proteinas || 0) || 0,
                    carbohidratos: Number(form.nutricion.resumen.carbohidratos || 0) || 0,
                    grasas: Number(form.nutricion.resumen.grasas || 0) || 0,
                },
                porcion: {
                    tamano: String(form.nutricion.porcion.tamano || '').trim(),
                    unidad: String(form.nutricion.porcion.unidad || 'g').trim(),
                    porciones_por_envase: String(form.nutricion.porcion.porciones_por_envase || '').trim(),
                },
                tabla: {
                    calorias_kcal: Number(form.nutricion.tabla.calorias_kcal || 0) || 0,
                    grasas_totales_g: Number(form.nutricion.tabla.grasas_totales_g || 0) || 0,
                    grasas_saturadas_g: Number(form.nutricion.tabla.grasas_saturadas_g || 0) || 0,
                    grasas_trans_g: Number(form.nutricion.tabla.grasas_trans_g || 0) || 0,
                    colesterol_mg: Number(form.nutricion.tabla.colesterol_mg || 0) || 0,
                    sodio_mg: Number(form.nutricion.tabla.sodio_mg || 0) || 0,
                    carbohidratos_totales_g: Number(form.nutricion.tabla.carbohidratos_totales_g || 0) || 0,
                    fibra_dietetica_g: Number(form.nutricion.tabla.fibra_dietetica_g || 0) || 0,
                    azucares_totales_g: Number(form.nutricion.tabla.azucares_totales_g || 0) || 0,
                    azucares_anadidos_g: Number(form.nutricion.tabla.azucares_anadidos_g || 0) || 0,
                    proteinas_g: Number(form.nutricion.tabla.proteinas_g || 0) || 0,
                },
                extra: Array.isArray(form.nutricion.extra) ? form.nutricion.extra.map((x) => ({
                    nombre: String(x?.nombre || '').trim(),
                    cantidad: String(x?.cantidad || '').trim(),
                    unidad: String(x?.unidad || '').trim(),
                    vd: String(x?.vd || '').trim(),
                })) : [],
                notas: String(form.nutricion.notas || '').trim(),
            },
        };

        const payload = {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),

            id: mode === 'edit' ? form.id : null,
            tipo: String(form.tipo || '').trim(),
            activo: Number(form.activo) ? 1 : 0,
            data: dataPayload,
            images_meta: { images_order: [], existing_urls: [] },
        };

        const fd = new FormData();
        fd.append('rute', payload.rute);
        fd.append('session_id', payload.session_id);
        fd.append('keylogin', payload.keylogin);

        let newFileCount = 0;
        images.forEach((im) => {
            if (im.kind === 'existing') {
                payload.images_meta.existing_urls.push(im.url);
                payload.images_meta.images_order.push(`u:${im.url}`);
            } else {
                fd.append('images[]', im.file, im.file?.name || `image_${newFileCount}.jpg`);
                payload.images_meta.images_order.push(`f:${newFileCount}`);
                newFileCount += 1;
            }
        });

        fd.append('payload', JSON.stringify(payload));

        try {
            await busyWrap(async () => {
                const res = await axios.post(`${path_api}/admin/platillos/upsert.php`, fd);

                if (res.data?.mensaje === 'success') {
                    globals.createAlert({ type: "success", msg_title: "Listo", msg: "Platillo guardado correctamente.", effect: "opacidad 1s, desplazamiento 1s", time_life: 2200 });
                    setDirty(false);
                    nav('/admin/platillos');
                    return;
                }

                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: res.data?.mensaje || "No se pudo guardar el platillo",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            });
        } catch (e) {
            console.error(e);
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al guardar el platillo",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        } finally {
            setSaving(false);
        }
    };

    const previewCover = images?.[0]?.url || '';
    const previewMacros = useMemo(() => {
        const r = form.nutricion?.resumen || {};
        return {
            kcal: Number(r.kcal || 0) || 0,
            p: Number(r.proteinas || 0) || 0,
            c: Number(r.carbohidratos || 0) || 0,
            g: Number(r.grasas || 0) || 0,
        };
    }, [form.nutricion]);

    return (
        <div className="tw-platillo-editor">
            <div className="tw-platillo-editor__shell">
                <div className="tw-platillo-editor__header">
                    <div className="tw-platillo-editor__head-left">
                        <button className="tw-platillos-btn" type="button" onClick={handleBack}>
                            <IconChevronLeft />
                            Volver
                        </button>

                        <div className="tw-platillo-editor__hgroup">
                            <div className="tw-platillo-editor__title">
                                {mode === 'create' ? 'Nuevo platillo' : mode === 'clone' ? 'Clonar platillo' : 'Editar platillo'}
                            </div>
                            <div className="tw-platillo-editor__subtitle">
                                {loading ? 'Cargando…' : 'Completa la info. La imagen #0 será portada.'}
                            </div>
                        </div>
                    </div>

                    <div className="tw-platillo-editor__head-right">
                        <div className={`tw-platillo-editor__pill ${form.activo ? 'tw-platillo-editor__pill--active' : 'tw-platillo-editor__pill--inactive'}`}>
                            {form.activo ? 'Activo' : 'Inactivo'}
                        </div>

                        <button className="tw-platillos-btn" type="button" onClick={handleBack} disabled={saving}>
                            <IconX />
                            Cancelar
                        </button>

                        <button className="tw-platillos-btn tw-platillos-btn--primary" type="button" onClick={handleSave} disabled={saving}>
                            <IconSave />
                            {saving ? 'Guardando…' : 'Guardar'}
                        </button>
                    </div>
                </div>

                <div style={{ display: 'grid', gap: 'var(--var-gap-10)' }}>
                    <div className="tw-platillo-editor__card">
                        <div className="tw-platillo-editor__section-title">Información básica</div>

                        <div className="tw-platillo-editor__grid2">
                            <div className="tw-platillo-editor__row">
                                <div className="tw-platillos-label">Nombre *</div>
                                <input className="tw-platillos-control" value={form.nombre} onChange={(e) => setField('nombre', e.target.value)} />
                            </div>

                            <div className="tw-platillo-editor__row">
                                <div className="tw-platillos-label">Tipo *</div>
                                <select className="tw-platillos-control" value={form.tipo} onChange={(e) => setField('tipo', e.target.value)}>
                                    <option value="entrada">Ensaladas</option>
                                    <option value="fuerte">Platos fuertes</option>
                                    <option value="snack">Snacks</option>
                                </select>
                            </div>
                        </div>

                        <div className="tw-platillo-editor__grid2">
                            <div className="tw-platillo-editor__row">
                                <div className="tw-platillos-label">Estado</div>
                                <select className="tw-platillos-control" value={form.activo ? '1' : '0'} onChange={(e) => setField('activo', e.target.value === '1' ? 1 : 0)}>
                                    <option value="1">Activo</option>
                                    <option value="0">Inactivo (equivale a “borrado”)</option>
                                </select>
                            </div>

                            <div className="tw-platillo-editor__row">
                                <div className="tw-platillos-label">Porciones por envase</div>
                                <input
                                    type='number'
                                    className="tw-platillos-control"
                                    value={form.nutricion.porcion.porciones_por_envase}
                                    onChange={(e) => setField('nutricion.porcion.porciones_por_envase', e.target.value)}
                                    placeholder="Ej: 1"
                                />
                            </div>
                        </div>

                        <div className="tw-platillo-editor__row">
                            <div className="tw-platillos-label">Descripción breve</div>
                            <textarea className="tw-platillo-editor__textarea" value={form.descripcion} onChange={(e) => setField('descripcion', e.target.value)} />
                        </div>

                        <div className="tw-platillo-editor__row">
                            <div className="tw-platillos-label">Disclaimer de alérgenos</div>
                            <textarea className="tw-platillo-editor__textarea" value={form.alergeno} onChange={(e) => setField('alergeno', e.target.value)} />
                        </div>
                    </div>

                    <div className="tw-platillo-editor__card">
                        <div className="tw-platillo-editor__section-title">Imágenes</div>

                        <div className="tw-platillo-editor__upload">
                            <div>
                                <div className="tw-platillo-editor__hint">
                                    La imagen #0 es la portada. Puedes reordenar con las flechas o marcar “portada”.
                                </div>
                            </div>

                            <label className="tw-platillos-btn" style={{ cursor: 'pointer' }}>
                                <input type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={(e) => handlePickImages(e.target.files)} />
                                <IconPlus />
                                Agregar
                            </label>
                        </div>

                        {images.length === 0 ? (
                            <div className="tw-platillos-empty">Sin imágenes.</div>
                        ) : (
                            <div className="tw-platillo-editor__thumbs">
                                {images.map((im, idx) => (
                                    <div className="tw-platillo-editor__thumb" key={im.key}>
                                        <div className="tw-platillo-editor__thumb-img">
                                            <img src={im.url} alt={`img_${idx}`} />
                                        </div>

                                        <div className="tw-platillo-editor__thumb-bar">
                                            <div className="tw-platillo-editor__thumb-tag">#{idx}</div>

                                            <div className="tw-platillo-editor__thumb-mini">
                                                <button className="tw-platillo-editor__miniicon" type="button" title="Subir" onClick={() => moveImage(idx, idx - 1)} disabled={idx === 0}>
                                                    <IconArrowUp />
                                                </button>
                                                <button className="tw-platillo-editor__miniicon" type="button" title="Bajar" onClick={() => moveImage(idx, idx + 1)} disabled={idx === images.length - 1}>
                                                    <IconArrowDown />
                                                </button>
                                                <button className="tw-platillo-editor__miniicon" type="button" title="Hacer portada" onClick={() => moveImage(idx, 0)} disabled={idx === 0}>
                                                    <IconStar />
                                                </button>
                                                <button className="tw-platillo-editor__miniicon" type="button" title="Quitar" onClick={() => removeImage(idx)}>
                                                    <IconTrash />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="tw-platillo-editor__card">
                        <div className="tw-platillo-editor__section-title">Nutrición (resumen para tarjetas)</div>

                        <div className="tw-platillo-editor__grid4 tw-platillo-editor__grid2">
                            <input type='number' className="tw-platillos-control" value={form.nutricion.resumen.kcal} onChange={(e) => setField('nutricion.resumen.kcal', e.target.value)} placeholder="Kcal" inputMode="numeric" />
                            <input type='number' className="tw-platillos-control" value={form.nutricion.resumen.proteinas} onChange={(e) => setField('nutricion.resumen.proteinas', e.target.value)} placeholder="Proteínas (g)" inputMode="numeric" />
                            <input type='number' className="tw-platillos-control" value={form.nutricion.resumen.carbohidratos} onChange={(e) => setField('nutricion.resumen.carbohidratos', e.target.value)} placeholder="Carbohidratos (g)" inputMode="numeric" />
                            <input type='number' className="tw-platillos-control" value={form.nutricion.resumen.grasas} onChange={(e) => setField('nutricion.resumen.grasas', e.target.value)} placeholder="Grasas (g)" inputMode="numeric" />
                        </div>

                        <div className="tw-platillo-editor__hint">
                            Esto es lo que el cliente verá rápido en el menú. La tabla nutrimental completa va abajo.
                        </div>
                    </div>

                    <div className="tw-platillo-editor__card">
                        <div className="tw-platillo-editor__section-title">Tabla nutrimental</div>

                        <div className="tw-platillo-editor__grid3">
                            <div className="tw-platillo-editor__row">
                                <div className="tw-platillos-label">Tamaño de porción</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.porcion.tamano} onChange={(e) => setField('nutricion.porcion.tamano', e.target.value)} placeholder="Ej: 250" />
                            </div>

                            <div className="tw-platillo-editor__row">
                                <div className="tw-platillos-label">Unidad</div>
                                <select className="tw-platillos-control" value={form.nutricion.porcion.unidad} onChange={(e) => setField('nutricion.porcion.unidad', e.target.value)}>
                                    <option value="g">g</option>
                                    <option value="ml">ml</option>
                                    <option value="pz">pz</option>
                                </select>
                            </div>

                            <div className="tw-platillo-editor__row">
                                <div className="tw-platillos-label">Calorías (kcal)</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.calorias_kcal} onChange={(e) => setField('nutricion.tabla.calorias_kcal', e.target.value)} inputMode="numeric" />
                            </div>
                        </div>

                        <div className="tw-platillo-editor__divider" />

                        <div className="tw-platillo-editor__table">
                            <div className="tw-platillo-editor__table-head">Nutrientes principales</div>
                            <div className="tw-platillo-editor__table-grid">
                                <div className="tw-platillo-editor__table-coltitle">Nutriente</div>
                                <div className="tw-platillo-editor__table-coltitle">Cantidad</div>
                                <div className="tw-platillo-editor__table-coltitle">Unidad</div>

                                <div>Grasa total</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.grasas_totales_g} onChange={(e) => setField('nutricion.tabla.grasas_totales_g', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>g</div>

                                <div>Grasa saturada</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.grasas_saturadas_g} onChange={(e) => setField('nutricion.tabla.grasas_saturadas_g', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>g</div>

                                <div>Grasa trans</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.grasas_trans_g} onChange={(e) => setField('nutricion.tabla.grasas_trans_g', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>g</div>

                                <div>Colesterol</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.colesterol_mg} onChange={(e) => setField('nutricion.tabla.colesterol_mg', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>mg</div>

                                <div>Sodio</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.sodio_mg} onChange={(e) => setField('nutricion.tabla.sodio_mg', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>mg</div>

                                <div>Carbohidratos totales</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.carbohidratos_totales_g} onChange={(e) => setField('nutricion.tabla.carbohidratos_totales_g', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>g</div>

                                <div>Fibra dietética</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.fibra_dietetica_g} onChange={(e) => setField('nutricion.tabla.fibra_dietetica_g', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>g</div>

                                <div>Azúcares totales</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.azucares_totales_g} onChange={(e) => setField('nutricion.tabla.azucares_totales_g', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>g</div>

                                <div>Azúcares añadidos</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.azucares_anadidos_g} onChange={(e) => setField('nutricion.tabla.azucares_anadidos_g', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>g</div>

                                <div>Proteínas</div>
                                <input type='number' className="tw-platillos-control" value={form.nutricion.tabla.proteinas_g} onChange={(e) => setField('nutricion.tabla.proteinas_g', e.target.value)} inputMode="numeric" />
                                <div style={{ display: 'flex', alignItems: 'center' }}>g</div>
                            </div>
                        </div>

                        <div className="tw-platillo-editor__divider" />

                        <div className="tw-platillo-editor__section-title">Nutrientes extra (opcional)</div>

                        {form.nutricion.extra?.length ? (
                            <div style={{ display: 'grid', gap: 'var(--var-gap-10)' }}>
                                {form.nutricion.extra.map((n, idx) => (
                                    <div key={`extra_${idx}`} className="tw-platillo-editor__grid3">
                                        <input className="tw-platillos-control" value={n.nombre} onChange={(e) => updateExtraNutriente(idx, 'nombre', e.target.value)} placeholder="Nombre (Ej: Calcio)" />
                                        <input className="tw-platillos-control" value={n.cantidad} onChange={(e) => updateExtraNutriente(idx, 'cantidad', e.target.value)} placeholder="Cantidad" />
                                        <div style={{ display: 'flex', gap: 'var(--var-gap-10)' }}>
                                            <input className="tw-platillos-control" value={n.unidad} onChange={(e) => updateExtraNutriente(idx, 'unidad', e.target.value)} placeholder="Unidad (mg, mcg)" />
                                            <input className="tw-platillos-control" value={n.vd} onChange={(e) => updateExtraNutriente(idx, 'vd', e.target.value)} placeholder="%VD" />
                                            <button className="tw-platillos-btn tw-platillos-btn--danger" type="button" onClick={() => removeExtraNutriente(idx)} title="Quitar">
                                                <IconTrash />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="tw-platillo-editor__hint">No hay nutrientes extra.</div>
                        )}

                        <button className="tw-platillos-btn" type="button" onClick={addExtraNutriente}>
                            <IconPlus />
                            Agregar nutriente extra
                        </button>

                        <div className="tw-platillo-editor__row">
                            <div className="tw-platillos-label">Notas de nutrición (opcional)</div>
                            <textarea className="tw-platillo-editor__textarea" value={form.nutricion.notas} onChange={(e) => setField('nutricion.notas', e.target.value)} />
                        </div>
                    </div>
                </div>

                <div className="tw-platillo-preview">
                    <div className="tw-platillo-preview__card">
                        <div className="tw-platillo-preview__cover">
                            {previewCover ? <img src={previewCover} alt="cover" /> : null}
                        </div>
                        <div className="tw-platillo-preview__body">
                            <div className="tw-platillo-preview__name">{form.nombre || 'Nombre del platillo'}</div>
                            <div className="tw-platillo-preview__desc">{form.descripcion || 'Descripción breve…'}</div>

                            <div className="tw-platillo-preview__row">
                                <div className="tw-platillo-preview__pill">{Math.round(previewMacros.kcal)} Kcal</div>
                                <div className="tw-platillo-preview__pill">P {Math.round(previewMacros.p)}g</div>
                                <div className="tw-platillo-preview__pill">C {Math.round(previewMacros.c)}g</div>
                                <div className="tw-platillo-preview__pill">G {Math.round(previewMacros.g)}g</div>
                            </div>

                            <div className="tw-platillo-preview__warn">
                                {form.alergeno ? form.alergeno : 'Sin disclaimer de alérgenos.'}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
